import { render, staticRenderFns } from "./RoHSDetailsV2.vue?vue&type=template&id=a3661f32&"
import script from "./RoHSDetailsV2.vue?vue&type=script&lang=js&"
export * from "./RoHSDetailsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports